import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import { useNotif } from '@orion.ui/orion';
import useSignatureBalanceService from '@/services/SignatureBalanceService';

type Props = SetupProps<typeof DashboardSignatureOrderAsideSetupService.props>

export default class DashboardSignatureOrderAsideSetupService extends BaseSetupService<Props> {
	static readonly props = {
		balance: {
			type: Object,
			required: true as const,
		},
	};

	readonly _aside?: OrionAside;

	private readonly state = reactive({
		comment: undefined,
		selectedPack: undefined,
	});

	readonly listPacks = [
		'Pack de 500 signatures',
		'Pack de 1 200 signatures',
		'Pack de 3 000 signatures',
		'Pack de 6 000 signatures',
	];

	get comment () { return this.state.comment; }
	set comment (val) { this.state.comment = val; }

	get selectedPack () { return this.state.selectedPack; }
	set selectedPack (val) { this.state.selectedPack = val; }


	constructor (props: Props, _aside?: OrionAside) {
		super(props);
		this._aside = _aside;
	}


	async sendOrderAsync () {
		this._aside?._loader()?.show(`Envoi de votre commande...`);
		try {
			await useSignatureBalanceService().orderSignatureAsync({
				id: this.props.balance.id,
				selectedPack: this.state.selectedPack,
				comment: this.state.comment,
			});
			useNotif.success(`Et voilà !`, `La commande de votre pack de signatures a bien été envoyée !`);
			this._aside?.close();
		} finally {
			this._aside?._loader()?.hide();
		}
	}
}
